import { render, staticRenderFns } from "./grantDialog.vue?vue&type=template&id=be66b5ca&scoped=true"
import script from "./grantDialog.vue?vue&type=script&lang=js"
export * from "./grantDialog.vue?vue&type=script&lang=js"
import style0 from "./grantDialog.vue?vue&type=style&index=0&id=be66b5ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be66b5ca",
  null
  
)

export default component.exports